import React, { useCallback, useState } from 'react';
import { ReactComponent as Logo } from '../../../assets/images/logo.svg';
import HandshakeImage from '../../../assets/images/affiliates/handshake.png';
import LogoImage from '../../../assets/images/affiliates/logo.png';
import NumberAndCoinImage from '../../../assets/images/affiliates/number-and-coin.png';
import PythagorusCalculatorImage from '../../../assets/images/affiliates/pythagorus-calculator.png';
import UrgeNumberImage from '../../../assets/images/affiliates/urge-number.png';
import './Affiliates.scss';

const Affiliates = () => {
  const [affiliateID, setAffiliateID] = useState('');
  const [trackingID, setTrackingID] = useState('');
  const [affilateTermsChecked, setAffilateTermsChecked] = useState(false);
  const [generateHoplinkClicked, setGenerateHoplinkClicked] = useState(false);
  const [hoplink, setHoplink] = useState('');

  const affiliateTerms = [
    'Affiliate advertising must not include content that is deceptive, misleading, untruthful, unsubstantiated, or otherwise fails to comply with applicable national, federal and state consumer protection laws, regulations, and guidelines.',
    'Affiliates are forbidden from creating webpages, social media pages or accounts that falsely represent themselves as the creators or owners of Mystic Numbers and must make it clear that the page is an Advertisement and that you are being compensated for any sales generated from it.',
    `Absolutely no negative or scare marketing tactic is permitted. No negatively worded or titled reviews or videos are allowed. This includes any use of the words 'scam', 'exposed' or similar.`,
    'Any kind of Email Spam is strictly prohibited. Emails should be sent only to people who have opted-in and should be fully CAN-SPAM compliant at all times.',
    'You may not copy, transcribe, paraphrase, reproduce or otherwise use in any format any video or part of video found on this website. ',
    'Any and all images found on this website are the property of this website and are copyright protected. They may only be used by affiliates in the promotion of Mystic Numbers. Any other use is strictly prohibited.',
    'Affiliates may not directly send customers to a checkout page. All customers must go through the proper hoplinks to the landing pages on this website.',
    'Affiliate agrees to indemnify, defend and hold harmless Mystic Numbers from any lawsuits, investigations, claims, or complaints arising from any such violation or alleged violation of the terms above. Mystic Numbers shall not be responsible to approve any Affiliate Ads. Compliance is solely with the Affiliate and the Affiliate represents and warrants that it shall have legal review of all Affiliate Ads for all necessary and required compliance. Affiliates take full responsibility for their advertising.',
    'Bonus offers have been created by the Vendor and not by Clickbank. Accordingly, ClickBank is not responsible for any information contained in the offer, including, but not limited to, any product information, promotions, incentives, expected returns or other information contained herein. In addition, ClickBank is not responsible for any links to third party websites in conjunction with this offer. Such links do not imply any endorsement by ClickBank of such websites or the content, products or services available from such websites. By clicking on or accessing a third party website listed, you acknowledge sole responsibility for and assume all risk arising from your use of any such websites.',
  ];

  const productImages = [
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-1.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-2.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-3.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-4.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-5.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-6.jpg',
    'https://mystic-numbers.s3.eu-west-2.amazonaws.com/product-image-7.jpg',
  ];

  const handleGenerateHoplink = useCallback(() => {
    if (affiliateID) {
      setGenerateHoplinkClicked(true);

      if (affilateTermsChecked) {
        setHoplink(
          `https://hop.clickbank.net/?affiliate=${affiliateID}&vendor=mysticnumb${
            trackingID ? '&tid=' : ''
          }${trackingID}`
        );
      }
    }
  }, [affilateTermsChecked, affiliateID, trackingID]);

  return (
    <div className="page-affiliates">
      <div className="container">
        <div className="hero">
          <Logo />
          <h2>Congratulations!</h2>
          <h3>You've found the Clickbank Goldmine</h3>
          <p>
            Supercharge your Clickbank profits with this amazing evergreen
            Numerology offer!
          </p>
        </div>
        <section className="welcome">
          <h3>Welcome to the Mystic Numbers Affiliates Page!</h3>
          <div className="flex-row">
            <div className="text-block">
              <p>
                A rare opportunity to promote the biggest and best EVERGREEN
                offer of the decade!
              </p>
              <p>
                Created by Diamond Clickbank vendors with multiple number 1
                offers and hundreds of millions in revenue you can rest assured
                this will explode your Clickbank account with affiliate
                commissions.
              </p>
              <p>THIS is the illusive offer you have been searching for...</p>
              <p>
                Are you ready to dive into a lucrative opportunity that not only
                offers exceptional value to your audience but also rewards you
                with substantial earnings?
              </p>
              <p>Look no further!</p>
            </div>
            <div className="image-block">
              <img src={NumberAndCoinImage} alt="number and coin" />
            </div>
          </div>
        </section>
        <section className="partner">
          <h3>Here's why partnering with us is the ultimate choice:</h3>
          <div className="ultimate-choice">
            <div className="ultimate-choice__item">
              <p className="item-title">Why Promote Our Numerology Product?</p>
              <p className="item-subtitle">Evergreen Product</p>
              <p className="item-body">
                Always in demand our products will sell for years, even decades
                and continue to generate a long term consistent stream of
                revenue for our affiliates.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">HUGE commissions</p>
              <p className="item-body">
                We pay you a whopping <strong>75%</strong> commission per sale
                and with our unbelievable conversions rate some top affiliates
                are already seeing consistent <strong>$2+ EPCs</strong>
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">Unparalleled Accuracy:</p>
              <p className="item-body">
                Our numerology product is meticulously crafted by industry
                experts, ensuring unparalleled accuracy in personalised readings
                and predictions.{' '}
              </p>
              <p className="item-body">
                Your audience will benefit from insights that genuinely resonate
                and guide them on their life's journey
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">
                Comprehensive and personalised readings:
              </p>
              <p className="item-body">
                Unlike generic readings, our numerology product offers
                comprehensive personalized readings, delving into various
                aspects of an individual's life: personality traits,
                relationships, career paths, and more.
              </p>
              <p className="item-body mb0">
                This depth of insight and personalisation keeps your audience
                engaged and eager for more.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">Proven Credibility:</p>
              <p className="item-body">
                Backed by rave reviews and a growing base of satisfied
                customers, our numerology product has established its
                credibility in the market.
              </p>
              <p className="item-body">
                By promoting it, you align yourself with a trusted and reputable
                brand.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title">
                Why Our Affiliate Program Stands Out:
              </p>
              <p className="item-subtitle">Generous Commission:</p>
              <p className="item-body mb10">
                We believe in rewarding our affiliates for their efforts. Enjoy
                a highly competitive commission structure that ensures you earn
                a substantial income for each successful referral.
              </p>
              <p className="item-subtitle">Super Low Refund Rates</p>
              <p className="item-body mb0">
                Customers love our products, and we provide top quality customer
                support meaning our refunds are SUPER LOW which means more money
                in YOUR pocket!
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">High Conversion Rates:</p>
              <p className="item-body mb10">
                Our numerology product's proven quality translates to high
                conversion rates. You'll find that your audience eagerly
                converts, thanks to the genuine value they perceive in the
                product.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">High Conversion Rates:</p>
              <p className="item-body mb10">
                Our numerology product's proven quality translates to high
                conversion rates. You'll find that your audience eagerly
                converts, thanks to the genuine value they perceive in the
                product.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">Tens Of Thousands In Prizes:</p>
              <p className="item-body mb10">
                From our biggest to our smallest affiliates we reward you all
                with competitions and bonuses throughout the year, stay up to
                date by signing up to our affiliates list below.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">Marketing Support:</p>
              <p className="item-body">
                Banners, email templates, social media content, and more. We
                equip you with the tools you need to launch successful campaigns
                effortlessly.
              </p>
            </div>
            <div className="ultimate-choice__item">
              <p className="item-title mb10">Unleash Your Earning Potential:</p>
              <p className="item-body mb0">
                Imagine watching your earnings soar as you introduce your
                audience to a product that genuinely transforms lives. With our
                Numerology Product Affiliate Program, you're not just promoting
                a product – you're offering a path to self-discovery and
                empowerment.{' '}
              </p>
            </div>
            <div className="ultimate-choice__item join-us">
              <img src={HandshakeImage} alt="handshake" />
              <p>Join us today and unlock limitless earning potential!</p>
            </div>
          </div>
        </section>
        <section className="affiliate-links">
          <div className="text-block">
            <h3>
              Create Your <br />
              Affiliate Links
            </h3>
            <p>
              Start running us today, and step into a future of unlimited
              earning potential with the power of Numerology.
            </p>
            <p>
              Become an affiliate now and start transforming lives, including
              your own!
            </p>
            <p>
              Use our hoplink generator to generate your personal affiliate link
              now.
            </p>
          </div>
          <div className="generate-form">
            <div className="generate-form__inner">
              <h3>Hoplink Generator:</h3>
              <div className="input-item">
                <label>Your Affiliate ID</label>
                <input
                  value={affiliateID}
                  onChange={(e) => setAffiliateID(e.target.value)}
                />
              </div>
              <div className="input-item">
                <label>Tracking ID (Optional)</label>
                <input
                  value={trackingID}
                  onChange={(e) => setTrackingID(e.target.value)}
                />
              </div>
              <div className="checkbox-item">
                <div
                  className={`checkbox-input ${
                    affilateTermsChecked
                      ? 'checked'
                      : generateHoplinkClicked
                      ? 'error'
                      : ''
                  }`}
                  onClick={() => {
                    setAffilateTermsChecked((old) => !old);
                    setGenerateHoplinkClicked(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="10"
                    viewBox="0 0 13 10"
                    fill="none"
                  >
                    <path
                      d="M11.4086 1.27632L4.59511 8.08984L1.35156 4.84634"
                      stroke="url(#paint0_linear_330_3376)"
                      strokeWidth="2"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_330_3376"
                        x1="1.35156"
                        y1="4.68308"
                        x2="11.4077"
                        y2="4.55142"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#4F0098" />
                        <stop offset="1" stopColor="#BD35DC" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <label>I have read the affiliate terms</label>
              </div>
              {hoplink && <div className="generate-hoplink">{hoplink}</div>}
              <div
                className="btn-gradient btn-generate"
                onClick={handleGenerateHoplink}
              >
                Generate Hoplink
              </div>
            </div>
          </div>
        </section>
        <section className="install-pixels">
          <div className="image-block">
            <img src={PythagorusCalculatorImage} alt="install pixels" />
          </div>
          <div className="text-block">
            <h3>Install Pixels</h3>
            <p>
              You can now place your tracking pixels (such as Facebook, Yahoo,
              Google, Voluum and more) directly in your Clickbank account.
            </p>
            <p>
              To get more information on how to use this service visit their
              page{' '}
              <a
                href="https://support.clickbank.com/hc/en-us/articles/220375827"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            </p>
          </div>
        </section>
        <section className="email-swipes">
          <div className="email-swipes__header">
            <div className="text-block">
              <h3>Email Swipes</h3>
              <p>Please email us for email swipes</p>
            </div>
            <div className="image-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="332"
                height="332"
                viewBox="0 0 332 332"
                fill="none"
              >
                <path
                  d="M60.3333 0.0834961C52.1076 0.0834961 45.25 6.94113 45.25 15.1668V78.888L3.34367 106.948C1.25561 108.348 0.00181 110.695 0 113.209V301.75C0 318.332 13.5848 331.917 30.1667 331.917H301.667C318.249 331.917 331.833 318.332 331.833 301.75V113.209C331.833 110.687 330.573 108.332 328.475 106.934L286.583 79.0058V15.1668C286.583 6.94113 279.726 0.0834961 271.5 0.0834961H60.3333ZM60.3333 15.1668H271.5V143.95L178.157 215.065C170.896 220.597 160.937 220.597 153.676 215.065L60.3333 143.95C60.3333 101.022 60.3333 58.0945 60.3333 15.1668ZM45.25 97.0352V132.46L20.5039 113.606L45.25 97.0352ZM286.583 97.1385L311.315 113.621L286.583 132.461V97.1385ZM15.0833 128.425L115.953 205.3L15.6284 305.624C15.3103 304.383 15.0833 303.107 15.0833 301.75V128.425ZM316.75 128.425V301.75C316.75 303.107 316.523 304.383 316.205 305.624L215.88 205.299L316.75 128.425ZM128.061 214.52L144.529 227.07C157.133 236.673 174.7 236.673 187.304 227.07L203.772 214.52L305.541 316.289C304.3 316.607 303.024 316.833 301.667 316.833H30.1667C28.8097 316.833 27.5339 316.607 26.2927 316.288L128.061 214.52Z"
                  fill="black"
                />
                <path
                  d="M98.0417 45.3335C96.0415 45.3335 94.1232 46.1281 92.7089 47.5424C91.2946 48.9567 90.5 50.875 90.5 52.8752C90.5 54.8753 91.2946 56.7936 92.7089 58.2079C94.1232 59.6223 96.0415 60.4168 98.0417 60.4168H233.792C235.792 60.4168 237.71 59.6223 239.124 58.2079C240.539 56.7936 241.333 54.8753 241.333 52.8752C241.333 50.875 240.539 48.9567 239.124 47.5424C237.71 46.1281 235.792 45.3335 233.792 45.3335H98.0417Z"
                  fill="black"
                />
                <path
                  d="M98.0417 83.0418C96.0415 83.0418 94.1232 83.8364 92.7089 85.2507C91.2946 86.6651 90.5 88.5833 90.5 90.5835C90.5 92.5837 91.2946 94.5019 92.7089 95.9163C94.1232 97.3306 96.0415 98.1252 98.0417 98.1252H233.792C235.792 98.1252 237.71 97.3306 239.124 95.9163C240.539 94.5019 241.333 92.5837 241.333 90.5835C241.333 88.5833 240.539 86.6651 239.124 85.2507C237.71 83.8364 235.792 83.0418 233.792 83.0418H98.0417Z"
                  fill="black"
                />
                <path
                  d="M98.0417 120.75C96.0415 120.75 94.1232 121.545 92.7089 122.959C91.2946 124.373 90.5 126.292 90.5 128.292C90.5 130.292 91.2946 132.21 92.7089 133.625C94.1232 135.039 96.0415 135.833 98.0417 135.833H233.792C235.792 135.833 237.71 135.039 239.124 133.625C240.539 132.21 241.333 130.292 241.333 128.292C241.333 126.292 240.539 124.373 239.124 122.959C237.71 121.545 235.792 120.75 233.792 120.75H98.0417Z"
                  fill="black"
                />
                <path
                  d="M48.2174 83.3196L50.5833 81.7354V78.888V15.1668C50.5833 9.88665 55.0532 5.41683 60.3333 5.41683H271.5C276.78 5.41683 281.25 9.88665 281.25 15.1668V79.0058V81.8601L283.625 83.4434L325.516 111.371C326.131 111.781 326.5 112.47 326.5 113.209V301.75C326.5 315.387 315.303 326.583 301.667 326.583H30.1667C16.5303 326.583 5.33333 315.387 5.33333 301.75V113.211C5.33432 112.475 5.70148 111.788 6.3126 111.379L48.2174 83.3196ZM60.3333 9.8335H55V15.1668V15.4184V15.6699V15.9214V16.1729V16.4245V16.676V16.9275V17.1791V17.4306V17.6821V17.9336V18.1852V18.4367V18.6882V18.9398V19.1913V19.4428V19.6944V19.9459V20.1974V20.4489V20.7005V20.952V21.2035V21.4551V21.7066V21.9581V22.2096V22.4612V22.7127V22.9642V23.2158V23.4673V23.7188V23.9703V24.2219V24.4734V24.7249V24.9765V25.228V25.4795V25.731V25.9826V26.2341V26.4856V26.7372V26.9887V27.2402V27.4918V27.7433V27.9948V28.2463V28.4979V28.7494V29.0009V29.2525V29.504V29.7555V30.007V30.2586V30.5101V30.7616V31.0132V31.2647V31.5162V31.7677V32.0193V32.2708V32.5223V32.7739V33.0254V33.2769V33.5284V33.78V34.0315V34.283V34.5346V34.7861V35.0376V35.2891V35.5407V35.7922V36.0437V36.2953V36.5468V36.7983V37.0499V37.3014V37.5529V37.8044V38.056V38.3075V38.559V38.8106V39.0621V39.3136V39.5651V39.8167V40.0682V40.3197V40.5713V40.8228V41.0743V41.3258V41.5774V41.8289V42.0804V42.332V42.5835V42.835V43.0865V43.3381V43.5896V43.8411V44.0927V44.3442V44.5957V44.8472V45.0988V45.3503V45.6018V45.8534V46.1049V46.3564V46.6079V46.8595V47.111V47.3625V47.6141V47.8656V48.1171V48.3686V48.6202V48.8717V49.1232V49.3748V49.6263V49.8778V50.1294V50.3809V50.6324V50.8839V51.1355V51.387V51.6385V51.8901V52.1416V52.3931V52.6446V52.8962V53.1477V53.3992V53.6508V53.9023V54.1538V54.4053V54.6569V54.9084V55.1599V55.4115V55.663V55.9145V56.166V56.4176V56.6691V56.9206V57.1722V57.4237V57.6752V57.9267V58.1783V58.4298V58.6813V58.9329V59.1844V59.4359V59.6874V59.939V60.1905V60.442V60.6936V60.9451V61.1966V61.4482V61.6997V61.9512V62.2027V62.4543V62.7058V62.9573V63.2089V63.4604V63.7119V63.9634V64.215V64.4665V64.718V64.9696V65.2211V65.4726V65.7241V65.9757V66.2272V66.4787V66.7303V66.9818V67.2333V67.4848V67.7364V67.9879V68.2394V68.491V68.7425V68.994V69.2455V69.4971V69.7486V70.0001V70.2517V70.5032V70.7547V71.0062V71.2578V71.5093V71.7608V72.0124V72.2639V72.5154V72.7669V73.0185V73.27V73.5215V73.7731V74.0246V74.2761V74.5276V74.7792V75.0307V75.2822V75.5338V75.7853V76.0368V76.2883V76.5399V76.7914V77.0429V77.2945V77.546V77.7975V78.049V78.3006V78.5521V78.8036V79.0552V79.3067V79.5582V79.8098V80.0613V80.3128V80.5643V80.8159V81.0674V81.3189V81.5705V81.822V82.0735V82.325V82.5766V82.8281V83.0796V83.3312V83.5827V83.8342V84.0857V84.3373V84.5888V84.8403V85.0919V85.3434V85.5949V85.8464V86.098V86.3495V86.601V86.8526V87.1041V87.3556V87.6071V87.8587V88.1102V88.3617V88.6133V88.8648V89.1163V89.3678V89.6194V89.8709V90.1224V90.374V90.6255V90.877V91.1285V91.3801V91.6316V91.8831V92.1347V92.3862V92.6377V92.8893V93.1408V93.3923V93.6438V93.8954V94.1469V94.3984V94.6499V94.9015V95.153V95.4045V95.6561V95.9076V96.1591V96.4107V96.6622V96.9137V97.1652V97.4168V97.6683V97.9198V98.1714V98.4229V98.6744V98.9259V99.1775V99.429V99.6805V99.9321V100.184V100.435V100.687V100.938V101.19V101.441V101.693V101.944V102.196V102.447V102.699V102.95V103.202V103.453V103.705V103.957V104.208V104.46V104.711V104.963V105.214V105.466V105.717V105.969V106.22V106.472V106.723V106.975V107.226V107.478V107.729V107.981V108.233V108.484V108.736V108.987V109.239V109.49V109.742V109.993V110.245V110.496V110.748V110.999V111.251V111.502V111.754V112.005V112.257V112.508V112.76V113.012V113.263V113.515V113.766V114.018V114.269V114.521V114.772V115.024V115.275V115.527V115.778V116.03V116.281V116.533V116.784V117.036V117.288V117.539V117.791V118.042V118.294V118.545V118.797V119.048V119.3V119.551V119.803V120.054V120.306V120.557V120.809V121.06V121.312V121.564V121.815V122.067V122.318V122.57V122.821V123.073V123.324V123.576V123.827V124.079V124.33V124.582V124.833V125.085V125.336V125.588V125.84V126.091V126.343V126.594V126.846V127.097V127.349V127.6V127.852V128.103V128.355V128.606V128.858V129.109V129.361V129.612V129.864V130.116V130.367V130.619V130.87V131.122V131.373V131.625V131.876V132.128V132.379V132.631V132.882V133.134V133.385V133.637V133.888V134.14V134.392V134.643V134.895V135.146V135.398V135.649V135.901V136.152V136.404V136.655V136.907V137.158V137.41V137.661V137.913V138.164V138.416V138.668V138.919V139.171V139.422V139.674V139.925V140.177V140.428V140.68V140.931V141.183V141.434V141.686V141.937V142.189V142.44V142.692V142.943V143.195V143.447V143.698V143.95V146.591L57.1012 148.192L150.444 219.307C150.444 219.308 150.444 219.308 150.444 219.308C159.614 226.294 172.219 226.294 181.389 219.308L274.732 148.192L276.833 146.591V143.95V15.1668V9.8335H271.5H60.3333ZM50.5833 97.0352V87.0451L42.2825 92.6037L17.5364 109.175L11.3364 113.326L17.2717 117.848L42.0178 136.703L50.5833 143.229V132.46V97.0352ZM289.541 92.7005L281.25 87.1747V97.1385V132.461V143.228L289.815 136.703L314.547 117.864L320.497 113.331L314.273 109.183L289.541 92.7005ZM18.3161 124.183L9.75 117.654V128.425V301.75C9.75 303.706 10.0784 305.452 10.462 306.948L12.7845 316.011L19.3996 309.396L119.724 209.071L124.039 204.756L119.186 201.058L18.3161 124.183ZM322.083 128.425V117.654L313.517 124.183L212.647 201.057L207.794 204.756L212.109 209.071L312.434 309.395L319.047 316.009L321.371 306.949C321.755 305.452 322.083 303.706 322.083 301.75V128.425ZM131.294 210.278L127.586 207.453L124.29 210.749L22.5215 312.517L15.9075 319.131L24.968 321.454C26.4649 321.838 28.2111 322.167 30.1667 322.167H301.667C303.622 322.167 305.368 321.838 306.864 321.455L315.928 319.134L309.312 312.517L207.544 210.749L204.247 207.453L200.54 210.278L184.072 222.828C173.377 230.976 158.456 230.976 147.761 222.828L131.294 210.278ZM96.4801 51.3136C96.8943 50.8995 97.456 50.6668 98.0417 50.6668H233.792C234.377 50.6668 234.939 50.8995 235.353 51.3136C235.767 51.7278 236 52.2895 236 52.8752C236 53.4608 235.767 54.0225 235.353 54.4367C234.939 54.8508 234.377 55.0835 233.792 55.0835H98.0417C97.456 55.0835 96.8943 54.8508 96.4801 54.4367C96.066 54.0225 95.8333 53.4608 95.8333 52.8752C95.8333 52.2895 96.066 51.7278 96.4801 51.3136ZM96.4801 89.022C96.8943 88.6078 97.456 88.3752 98.0417 88.3752H233.792C234.377 88.3752 234.939 88.6078 235.353 89.022C235.767 89.4361 236 89.9978 236 90.5835C236 91.1692 235.767 91.7309 235.353 92.145C234.939 92.5592 234.377 92.7918 233.792 92.7918H98.0417C97.456 92.7918 96.8943 92.5592 96.4801 92.145C96.066 91.7309 95.8333 91.1692 95.8333 90.5835C95.8333 89.9978 96.066 89.4361 96.4801 89.022ZM96.4801 126.73C96.8943 126.316 97.456 126.084 98.0417 126.084H233.792C234.377 126.084 234.939 126.316 235.353 126.73C235.767 127.144 236 127.706 236 128.292C236 128.878 235.767 129.439 235.353 129.853C234.939 130.268 234.377 130.5 233.792 130.5H98.0417C97.456 130.5 96.8943 130.268 96.4801 129.853C96.066 129.439 95.8333 128.878 95.8333 128.292C95.8333 127.706 96.066 127.144 96.4801 126.73Z"
                  stroke="url(#paint0_linear_330_3392)"
                  strokeOpacity="0.77"
                  strokeWidth="10.6667"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_330_3392"
                    x1="173.916"
                    y1="329.88"
                    x2="171.303"
                    y2="15.7037"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#4F0098" />
                    <stop offset="1" stopColor="#BD35DC" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </section>
        <section className="product-images">
          <div className="product-images__header">
            <h3>Product Images</h3>
            <p>
              You can use these copyrighted images and banners for any promotion
              of Plateso only (no other use is permitted without written
              permission).
            </p>
            <p>
              Click on any image and it will open in a new window then right
              click 'Save As' to download it onto your device.
            </p>
          </div>
          <div className="product-images__content">
            <div className="images-columns-3">
              {productImages.slice(0, 3).map((productImage, i) => (
                <a key={i} href={productImage} target="_blank" rel="noreferrer">
                  <img src={productImage} alt={`product ${i + 1}`} />
                </a>
              ))}
            </div>
            <div className="images-columns-4">
              {productImages.slice(3, 7).map((productImage, i) => (
                <a
                  key={i + 3}
                  href={productImage}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={productImage} alt={`product ${i + 4}`} />
                </a>
              ))}
            </div>
          </div>
        </section>
        <section className="cover-pdf">
          <div className="cover-pdf__inner">
            <img className="logo" src={LogoImage} alt="logo" />
            <img
              className="urge-number"
              src={UrgeNumberImage}
              alt="urge number"
            />
          </div>
        </section>
        <section className="affiliate-terms">
          <div className="affiliate-terms__header">
            <h3>Affiliate Terms</h3>
            <p>
              Each participant in the affiliate program offered by Mystic
              Numbers (the "Vendor") currently through Clickbank (the
              "Retailer") expressly agrees to this affiliate agreement.
            </p>
          </div>
          <div className="affiliate-terms__content-desktop">
            <div className="left-content">
              {affiliateTerms
                .filter((_v, i) => i % 2 === 0)
                .map((sentence, i) => (
                  <div className="terms-item" key={i}>
                    <div className="number-box">{i * 2 + 1}</div>
                    <p>{sentence}</p>
                  </div>
                ))}
            </div>
            <div className="right-content">
              {affiliateTerms
                .filter((_v, i) => i % 2 === 1)
                .map((sentence, i) => (
                  <div className="terms-item" key={i}>
                    <div className="number-box">{(i + 1) * 2}</div>
                    <p>{sentence}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className="affiliate-terms__content-mobile">
            {affiliateTerms.map((sentence, i) => (
              <div className="terms-item" key={i}>
                <div className="number-box">{i + 1}</div>
                <p>{sentence}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="contact-us">
          <h3>Contact Us</h3>
          <p>
            If you have any questions, please don't hesitate to contact us at{' '}
            <a href="mailto:affiliates@mysticnumbers.com">
              affiliates@mysticnumbers.com
            </a>{' '}
            we look forward to having you on board.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Affiliates;
